import React from 'react';
import OpenLDAPBenefitCard from './OpenLDAPBenefitCard';

interface OpenLDAPBenefitsProps {
  title: string;
  description: string;
  items: Array<{
    title: string;
    description: string;
  }>;
}

const OpenLDAPBenefits: React.FC<OpenLDAPBenefitsProps> = ({
  title,
  description,
  items
}) => {
  return (
    <div className="bg-blue-50 rounded-2xl p-8 lg:p-12">
      <div className="text-center">
        <h3 className="text-2xl font-semibold text-gray-800">{title}</h3>
        <p className="mt-4 text-gray-600 max-w-3xl mx-auto">{description}</p>
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((benefit, index) => (
          <OpenLDAPBenefitCard
            key={index}
            {...benefit}
          />
        ))}
      </div>
    </div>
  );
};

export default OpenLDAPBenefits;